import { RequestInfo, ResponseOptions, STATUS } from 'angular-in-memory-web-api';
import { Injectable } from '@angular/core';
import { InMemoryHttpClient } from './in-memory-http-client';
import { Observable } from 'rxjs';

/**
 * This service intercepts {@link EmailService} requests and redirects them to an in-memory data store.
 */
@Injectable({
  providedIn: 'root',
})
export class InMemoryEmailDataService implements InMemoryHttpClient {

  /**
   * Intercepts HTTP GET request of {@link EmailService}.
   * @param reqInfo information about the current HTTP GET request.
   */
  get(reqInfo: RequestInfo) {
    return undefined;
  }

  /**
   * Intercepts HTTP DELETE request of {@link EmailService}.
   * @param reqInfo information about the current HTTP DELETE request.
   */
  delete(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP POST request of {@link EmailService}. Returns HTTP 200 status, so it will look like the email has been sent.
   * @param reqInfo information about the current HTTP POST request.
   */
  post(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return reqInfo.utils.createResponse$(() => {
      return {
        status: STATUS.OK,
      };
    });
  }

  /**
   * Intercepts HTTP PUT request of {@link EmailService}.
   * @param reqInfo information about the current HTTP PUT request.
   */
  put(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP PATCH request of {@link EmailService}.
   * @param reqInfo information about the current HTTP PATCH request.
   */
  patch(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }
}
